import LinearProgress, { linearProgressClasses, type LinearProgressProps } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const LinearProgressDeterminate = (props: LinearProgressProps) => (
  <LinearProgress variant="determinate" {...props} />
);

export const CustomLinearProgress = styled(LinearProgressDeterminate)(({ theme }) => ({
  height: 8,
  borderRadius: 6,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.backgroundColor,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 6,
    backgroundColor: theme.palette.accent,
  },
}));